module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-one"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Off Lisbon—June 1814")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("epairing a gash in a man’s brawny forearm on a ship’s deck bore not the slightest resemblance to mending a rip in a petticoat, Alice Fulton decided. She dabbed at the dried blood around the wound with a cloth moistened in seawater.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The prospect of causing pain gave it a wholly different aspect. The ship’s pitch and yaw added a further challenge. Fortunately, clear skies and a light breeze kept the motion to a minimum and the awning above their heads protected them from the midday heat.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Roped in as an unwilling assistant, her fellow passenger and best friend, Lady Selina Albright, stared grimly out to sea as if her life depended on it.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Perched in front of her on a barrel, with a three-inch gash in his sun-bronzed skin, her patient, Perkin, seemed remarkably unperturbed. But then she hadn’t told the sullen fellow staring at the planks at his feet that this was the first wound she’d actually stitched herself. No sense in scaring him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Not that much would scare this strapping sailor. Even with his head respectfully lowered and his bearded face hidden by the tangle of dark-brown hair falling around his shoulders, he had a swagger.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘When did you do this?’ she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘The night afore I came aboard,’ he muttered, not looking up. ‘I told you, miss, it ain’t nothing. I’ll take care of it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She’d caught him bandaging it one-handed when she passed the galley. On this merchant ship, the cook doubled as surgeon and he could hardly sew himself. ‘It needs sutures.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He glanced up, giving her a brief impression of a face younger than she’d first thought and handsome in a harsh, unkempt sort of way. His cheeks above the black-bearded jaw had been tanned to the colour of light mahogany. Deep creases radiated from the corners of eyes the strangest shade of turquoise rimmed with grey. Right now they held a distinctly resentful gleam. Or even anger? He lowered his head before she could be sure.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A feeling of unease disturbed her normally calm stomach. He’d been making her nervous since he had joined their ship in Lisbon, replacing their original cook who had disappeared amid the stews on the wharf. They’d certainly lost in the exchange. What Perkin knew about cooking he must have learned from a tanner. She stared at the large, strong, well-shaped hand resting on a formidably muscled thigh. At least his fingernails were clean.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" No matter how bad his food or his attitude, this wound needed sewing.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Ugh.’ Selina gave a delicate shudder. ‘You should let the sailmaker do it as Captain Dareth ordered,’ she said in her naturally breathy voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Perkin nodded agreement, his strange eyes warming as they roved over Selina’s lush figure.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Alice wanted to hit him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Why, she couldn’t imagine. There wasn’t a man alive whose eyes wouldn’t warm when they fell on Selina’s dark flamboyance, whereas Alice’s immature figure, nondescript brown hair and hazel eyes, rarely warranted a second look. Which suited Alice down to the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Hodges won’t be off watch for hours,’ she muttered, threading her needle. ‘The longer the wound remains open the less likely it will heal.’ And besides this might be her only chance to make use of her knowledge.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Are you certain you know how?’ Selina’s voice quavered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Certain? She stared at the bloody gash. In theory, yes. Practice was an altogether different proposition.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘This fascination of yours for surgery is positively macabre.’ Selina gave another of her carefully honed shudders.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" At least her friend wasn’t calling her interest unladylike, as Father did. He’d always blamed it on the months she’d spent on the long round trip to India with nothing to do but follow the surgeon around. At nine, she’d been half in love with the ship’s doctor. Her interest in medicine had survived the years. Love was a whole other story.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Be ready to hand me the scissors. And don’t look. I don’t want you fainting.’ Lord, she didn’t want to faint herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She lined up her needle.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Prickles darted down her back. Sweat trickled cold between her breasts and clung to her palms. The needle seemed to slither in her grasp like a maggot in a ship’s biscuit.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Now or never, Alice.")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She inhaled a deep breath. The ship rolled. She staggered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Perkin put out a hand. Caught her wrist. ‘Steady, miss.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His palm was warm, strong, calloused. A touch that burned. His eyes flashed concern. He released her swiftly as if he too had felt the sudden burst of heat.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Ridiculous.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She braced against the roll of the ship, absorbed the motion with her knees as she’d been doing for days. She swallowed to relieve the dryness in her throat. ‘Ready, Perkin?’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He grunted.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Pulse racing, she pressed the needle into the bronzed skin. It dimpled. Her hand shook.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘If yer goin’ to do it, give it a good hard jab,’ Perkin muttered in a growl.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Right. Alice stabbed. The needle punctured the skin. The man didn’t flinch, but she knew from a hitch in his breath she’d caused pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Forgive me,’ she murmured.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Surprise glimmered in his blue eyes, before he looked away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She pushed through the other side of the gash, pulled up and knotted. Mr Bellweather would have been proud. Good. And no blood. ‘Scissors, please.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" They appeared in front of her, dangling at the end of lacy gloved fingers.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She snipped the thread and returned the scissors to Selina’s outstretched palm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Alice let her breath go, felt her heart steady, and stabbed again. ‘Four stitches should do it,’ she murmured.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Head averted, Perkin started whistling ‘Spanish Ladies’ under his breath as if he hadn’t a care in the world. She had to admire his fortitude after hearing many a man whine like a puppy when faced with a stitch or two. His calmness instilled her with courage and in no time at all there were four nice neat knots along the puckered skin.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Bandage, Selina, please.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The bandage appeared under her nose.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Ceasing his whistle, Perkin inspected his arm, his expression hidden by the mass of black hair. ‘Thank ye.’ The tone sounded grudging.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She ignored his sullenness and smiled. ‘I think it will be all right.’ They wouldn’t know for a day or two if the gash would heal properly. If it didn’t, if she’d made things worse… Her stomach clenched. Don’t think that. She’d done a good job. Carefully she wrapped the bandage around a sun-weathered, sinewy forearm strong enough to haul up a mainsail by itself, if needed. She tied the strip of cloth off. ‘I will look at it later today.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Nah, miss. I’ll look a’ter it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Disappointed, but unsurprised by his reticence, Alice nodded. ‘As you wish. Please take more care next time you gut a fish.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" That startling gaze whipped up to her face. Not angry this time, more puzzled. ‘Aye, aye, miss.’ He rolled down his shirtsleeve, covering up all those lovely muscles.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Oh, Lord. Had she really just thought a common sailor’s arm lovely? Was she turning into one of those eccentric spinsters who peered at males sideways and made up stories in their heads?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘That’s that, then.’ She rinsed her hands in the bowl and handed it to Perkin, along with the cloth she had used. He took them without a word and headed below.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A sense of disappointment invaded her chest. She made a wry grimace. What had she expected from such a surly man? Effusive thanks? She wiped her face and the back of her neck with her handkerchief. He was probably horrified at the thought of a lady lowering herself to touch him. Men of all classes were odd in that regard.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Alice?’ Selina said, a strange note in her voice. ‘What are they looking at?’ She pointed to the bulwark where all of the ship’s officers were clustered at the starboard rail with their spyglasses directed astern. Between the master and his second officer, her brother Richard’s fifteen-year-old gangly body looked distinctly out of place. Like the others, he was watching a ship drawing down on them. Its present course would bring it exceedingly close to the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conchita")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(". Hairs rose on the back of her neck. Her stomach gave a roll in direct opposition to the movement of the ship. ‘Oh, no.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘What is it?’ Selina asked, her face anxious, her bright green eyes wide.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It couldn’t be. Not on this voyage, when they’d taken the utmost precautions. ‘It’s probably a ship looking for news,’ she said, heading to the rail. Everyone sought news these days, with rumours of peace circulating the docks.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Wait,’ Selina called. ‘Your parasol. You know how you burn.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" With a huff of impatience, Alice turned back to retrieve the lacy object from her friend. She smiled her thanks, took Selina’s arm and joined Mr Anderson, her father’s factotum, at the rail.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘What ship is it?’ Alice asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mr Anderson grimaced. ‘Can’t see from this angle, Miss Fulton. She’s flying the Union Jack.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Alice breathed a sigh of relief. Thomas Anderson chewed on his bottom lip. ‘I think you and Lady Selina should go below.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Why?’ Selina asked, her wide-eyed gaze turning to the middle-aged man who immediately turned pink. He’d been blushing every time she so much as glanced his way since they had left port. Not that Selina gave him the slightest encouragement. She simply took admiration as her due. Alice suppressed her irritation. She was past being interested in men of any sort.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Captain Dareth lowered his glass. ‘Let’s see if we can outrun her.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The tense low mutter added pressure to Alice’s already taut chest. She kept silent as the second officer rushed off shouting orders for more sail. The captain didn’t need additional worries.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Richard, obviously brimming with excitement, turned to the master. ‘She’s fast for a brig.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘She is that,’ Captain Dareth said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘A privateer, do you think?’ Richard ask, his adolescent voice cracking with excitement.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Alice gasped. A run-in with a privateer was the worst possible scenario. With England at war with France and her allies, as well as America, too many nations had given out letters of marque. The legal document allowed greedy captains with fast ships to take as prizes any enemy merchantmen trying to slip through the blockade. They were little better than pirates, but they had the law on their side.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Until now, Fulton’s Shipping had prided itself on following international law to the letter, but the situation had become intolerable, with ships being routinely stopped. She glanced up at their Spanish flag with a wince. Perhaps after all it had not been such a good idea to hide their national identity. If only they hadn’t been quite so desperate to make sure this cargo reached England safely.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Is it a privateer?’ she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The captain jerked his head around as if he’d only just noticed her presence. ‘Miss Fulton, I really must ask you to go below. And you, too, Lady Selina. Mr Anderson, please escort the ladies.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Do you think it is a privateer, Captain Dareth?’ Alice asked firmly, aware of the heightened clamour of her heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The captain’s gaze shifted above her shoulder, then travelled up the mainmast to the sails being unfurled by his crew. ‘I don’t know, Miss Fulton. There were rumours in Lisbon.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" There were always rumours. ‘But you think it might be.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Selina gave a little squeak of terror. ‘Are we in danger?’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘I must take every precaution,’ the captain said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mr Anderson took Selina’s elbow and reached for Alice’s arm. ‘Ladies, if you please?’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘No,’ Alice said. ‘Selina, go below if you wish, but it is as hot as Hades down there. Surely the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conchita ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("will easily outrun her.’ The ship had been specially designed for speed. Father had thrown every last penny into making her one of the fastest merchantmen operating out of England.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Clearly unwilling to argue with his employer’s daughter, Mr Anderson turned his attention to Selina. He escorted her down the nearby companionway.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘It would be pretty exciting if it is a privateer,’ Richard said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The captain rolled his eyes. ‘Excuse me, Miss Fulton.’ He hurried off to confer with his first officer. A couple of crew members were taking down the shade awning, the rest hauled on sheets to the second officer’s command in grim silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The pursuing brig was now close enough to see crewmen moving around on its deck.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Richard raised his glass to his eye. ‘They are gaining on us.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Boys. All they cared about was speed and danger. Hadn’t he learned anything on this voyage? This cargo was Father’s last hope—their family’s last hope—to salvage their fortunes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She forced a smile. ‘Pray he doesn’t catch us instead of cheering him on.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Richard looked down at her, his boyish face suddenly serious. ‘I’m not on his side, Alice. But you have to admire such a fine ship.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘I’d prefer to admire it far behind in our wake.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Richard returned the glass to his eye. ‘Strange decking aft. High for a brig. Doesn’t seem to slow her speed.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Apparently not. The brig’s bow was almost level with the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conchita")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("’s stern. Please, please, let him break a mast, or foul his rudder. Anything, so they weren’t caught. Her hands gripped the parasol handle so tightly, they hurt. She snapped the blasted thing closed. Who cared about freckles when minute by minute their pursuer narrowed the patch of ocean between the ships?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Only yards from their rail, the Union Jack on the other ship’s mast went down and the American flag rose. In the stern a large blue flag unfurled bearing the image of a gryphon in gold, all sharp claws and gleaming teeth.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘I knew it,’ Richard crowed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Alice gritted her teeth, and yet she couldn’t help but stare in fascination at the approaching ship’s elegant lines.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A puff of smoke emerged from the privateer’s bow. A thunderous bang struck their ears. Alice jumped. Selina’s scream pierced the deck’s planking from below. A plume of water fountained ahead of the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conchita")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(". A warning shot. The maritime signal to halt.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The captain issued a rapid order to the helmsman, who dragged the wheel hard over. The ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conchita ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("heeled away from their pursuer. Alice grabbed for the rail as the deck slanted away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘That surprised her,’ Richard muttered, one arm hooked around a rope.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The privateer’s sails flapped empty of wind.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Oh, good show. She’s in irons.’ Richard hurried off to join the captain at the helm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Not for long,’ Mr Anderson said gloomily, joining Alice at the rail. Out of the corner of her eye, Alice saw Perkin emerge through the hatch and take in the scene.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘You,’ an officer shouted. ‘To the yards.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Perkin made for the stern.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" With her heart in her throat and unable to do more than gaze with horrified fascination, Alice watched the privateer’s swift recovery. She swung across the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conchita")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("’s wake, then clawed her way up their port side. All down the length of the sleek-looking ship, black squares of open gun ports bristled with nasty-looking muzzles.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Surely he’s not going to fire at civilians?’ she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Someone came up behind her. As she turned to see who it was, a steely arm went around her waist and a pistol pressed against her temple. She stared at Perkin’s grim profile with a cry of shock.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Sorry, Miss Fulton,’ he muttered. ‘Do as you are bid and no harm will befall you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Captain Dareth,’ he roared. ‘Surrender.’ Her ears rang with his bellow.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The rise of Perkin’s chest with each indrawn breath pressed hot against her back. Sparks ran down her spine and lit a glow low in her stomach in a most inappropriate way. How could she respond to this criminal with such unladylike heat?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She jabbed Perkin’s ribs with her elbow. She might as well have poked a granite rock with her baby finger for all the notice he took. Come to think of it, his stomach gave less than granite, although she did hear a faint grunt.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Dareth,’ he yelled again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The captain turned, his eyes as round as marbles, his jaw dropping to his neatly knotted cravat. He stood stock-still and stared.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Perkin cursed harshly. ‘Strike your colours, man, before someone gets hurt.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Even dazed with astonishment, Alice couldn’t help but notice the change in the cook from common sailor to a man used to command.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She twisted in his grip. ‘You’re part of this.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Silence,’ he snarled.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A cannon boomed. A tearing rush of air whistled overhead. Then the ship seemed to disintegrate in the sound of splintering wood and the shouts. A spar, tangled with ropes and sail, slammed on to the deck. One end knocked Richard sideways. He collapsed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The breath rushed from Alice’s throat. She struggled to find her voice, fought to break the iron grip around her waist.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Richard,’ she screamed. She stilled at the pistol’s increased pressure. ‘Hold still,’ he growled in her ear.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Let me go. My brother needs help.’ She stamped down on his bare instep.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He uttered a foul curse, but the rock-hard grip didn’t ease a smidgeon.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Beside the helm, their captain’s face blanched. He gave the order to strike their colours.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘About bloody time,’ Perkin muttered as their flag fluttered to the deck. ‘Heave to,’ he shouted. The helmsman brought the ship around and the sails hung limp. The other ship drew alongside and men leaped across the gap into the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conchita")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("’s ratlines. Privateers poured on to their ship.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Get your brother below,’ Perkin said, pushing her forwards. He strode for the rail.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Heart faltering, terrified of what she would find, she ran to Richard’s side. One end of the spar lay across his chest. Ropes and canvas littered the deck around his still body. A blue lump marred his temple. ‘Richard,’ she cried, shaking his shoulder. He didn’t move.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She pressed her ear to his heart. A strong steady heartbeat. Thank God.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Now if she could move this timber… With shaking hands, she crouched and grabbed one end of the huge spar. Too heavy. It didn’t move. Muscles straining, she heaved again. Hopeless. She needed help.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She looked around wildly. For all that they looked like a motley crew, the privateers were swiftly and efficiently rounding up ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conchita")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("’s crew at pistol and sabre point. Not one of them looked her way.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A sailor ran past. She caught his arm. ‘You. Give me a hand here.’ The grey-haired, barrel-chested gnome of a man stopped in his tracks. His button-black eyes blinked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Help me move this spar,’ she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He glanced down at Richard. ‘Aye, aye, miss.’ He pulled out a knife, held it over her brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Alice’s breath caught in her throat. ‘Please. No.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The man slashed the ropes free and glanced up. ‘Did you say something, miss?’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Panting, her heart still thundering too hard for speech, Alice shook her head.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The man proceeded to lift one end of the spar and to drag it clear.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Perkin told me to get him below deck,’ she said, going to Richard’s feet. ‘You must help me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The man looked blank. ‘Can’t, miss. Speak to the captain.’ He rushed off.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She glanced around for someone else. Within the few short minutes she’d been busy with Richard, the privateers, twenty or more of them and all as rough as Perkin, had taken command of her father’s ship and were clearing the deck of torn sails, broken spars and damaged rigging. An acrid smell lingered in the air, the smell of gunpowder from the shots they had fired.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Oh Lord, what a disaster. And they could have been killed. An enormous lump rose up from her chest and stuck firm in her throat. She swallowed the rush of panic. Richard needed help. But who would give it?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A blond Viking of a man was striding aft issuing orders as he went. This must be the captain. She started towards him. He paused to speak to the traitorous Perkin, who appeared to have grown a foot since the privateers came on board. She marched across the deck and planted herself in front of both men. ‘My brother needs help.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The blond man recoiled. ‘Good God. A woman? What’s she doing on deck?’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A shade taller than his captain and as dark as the other man was fair, Perkin muttered into the blond giant’s ear.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘You, Perkin,’ she said. ‘Tell your captain this is an honest merchant ship carrying civilian passengers.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The blond giant raised a brow at his accomplice. ‘Michael?’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘You know what to do,’ Perkin said and strode away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Simpson,’ the captain shouted. ‘Get your sorry self over here.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The grey-bearded man who had freed Richard ran over.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘He wants her on the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gryphon")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(",’ the captain said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Her?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Simpson’s eyebrows shot up to his hairline. ‘Aye, aye, sir. This way, miss.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘I’m not going anywhere,’ Alice said. ‘My brother is injured.’ She dodged around the portly fellow and dashed back to her pale and still brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A hand fell on her shoulder. She jerked around to find a rough-looking sailor with a drooping moustache and a tarry pigtail staring at her from mud-coloured eyes. He grinned.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She tried not to notice the blackened stumps of his teeth. ‘Take him below.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The sailor’s eyes lit up. ‘I’ll be happy to take ye below, missy.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Get away from her, Kale.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Perkin again, with a pistol in his hand and his eyes blazing fury.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Her insides did a strange kind of somersault. The kind that shouldn’t be happening for any man, let alone a pirate even if he had defended her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Back to your duties, Kale,’ Perkin ordered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Kale seemed to shrivel. He gave a half-hearted salute. ‘Aye, sir.’ He shambled off.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A rather red-looking Simpson appeared at Perkin’s side. Perkin gave him a frown. ‘Damnation, Simpson, get her on board the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gryphon ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("before she causes any more trouble.’ He narrowed his eyes and leaned closer to Simpson and muttered something in his ear.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The crewman’s eyes widened, then he touched his forelock with a wink. ‘Aye, aye.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘No,’ Alice said, ‘not without Richard’, but Perkin strode off as if she hadn’t said a word.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Orders is orders, miss,’ Simpson said, his black eyes twinkling.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He grabbed her around the waist and tossed her effortlessly over his shoulder. She landed hard on the bony point. It knocked the breath from her lungs. ‘Ouch, you brute! Put me down.’ She thumped him on the back. Kicked at his stomach. ‘I’m not going anywhere without my brother.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The man’s only response was a laboured grunt. He strode across the deck and dropped her into a canvas bucket hanging off the side of the ship. The scoundrels had rigged up ropes and a pulley between the ships, no doubt intending to steal everything of value.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Oh, God. The cargo. They were ruined.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She tried to scramble out again. ‘I can’t leave my brother.’ Or Selina. She’d be terrified witless. Who knew what a dreadful man like Kale would do? ‘My friend is below deck. You have to bring her too.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Simpson hopped in next to her and grasped her arm. ‘Be still, miss. I ain’t wanting to hurt ye. Haul away,’ he yelled at a sailor on the other ship handling the ropes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She clung to the edge of the bucket, her stomach pitching like a rowboat in a storm, staring back at the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conchita")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(", trying to see what was happening. Was someone bending over Richard? She raised up on tiptoes. Dash it. She couldn’t see.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Simpson must have seen her dismay, because his expression turned almost fatherly. ‘Don’t ye be worrying about yer friends. The captain will see to ’em.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" See to them? Why didn’t that make her feel any better? Indeed, her stomach churned worse than before and her throat dried as if she’d swallowed an ocean of seawater. ‘You have to go back for them.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The bucket bumped against the side of the brig and Simpson hopped out. He made a grab for her. She backed away. The twinkle in his eyes disappeared. ‘Now then, miss, do as I say, or you and your friends will have more trouble than you bargained for.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She stilled. She had no wish to bring harm to Richard and Selina.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" An elderly seaman with a cherry-red nose traced with blue veins hurried up to them. Strands of greying hair clung to his scalp, his bloodshot-grey eyes looked anxious. ‘Anyone hurt?’ he asked Alice’s gaoler.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Yes,’ Alice said. ‘My brother. He’s received a blow to the head.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The man, the doctor she assumed, blinked. ‘Hmm. What’s she doing here?’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Captain’s orders.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Women. Nothing but bad luck.’ He climbed into the bucket. ‘Haul away, man,’ he said to the other sailor.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Alice clutched at Simpson’s shirt. ‘He will look at my brother, won’t he?’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘That will be up to the captain.’ He must have seen the protest forming on her lips because he hurried to say, ‘If you do exactly what I says, I’ll make sure he does.’ He pushed her towards the stern, towards the ornately carved walls of the strange-looking poop-deck. It reminded her of pictures of ancient Spanish galleons, only smaller.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Biting her lip, she let him hurry her along.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Simpson opened a brass-fitted mahogany door and ushered her into a chamber lit by the floor-to-ceiling square-paned window angled back over the stern. Surprisingly, the cabin’s furnishings were sumptuous. A Turkish carpet covered the floor, a mahogany desk and a throne-like gilt chair occupied the centre of the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Beneath a skylight, an enormous bed covered in fine white sheets filled an alcove. A black gryphon, wings spread wide, curved beak open, and lion claws raking, sprang from the headboard.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The stuff of nightmares.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" This must be their captain’s stateroom. Why bring her here? Her heart thumped a warning. She turned to leave and found her way blocked by a sympathetic-looking Simpson.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" ‘Make yourself comfortable, miss.’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He backed out of the door. She heard the key turn in the lock.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Make herself comfortable? Wasn’t that like telling someone falling off a cliff to enjoy the journey?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Beyond the window, the azure sky and sparkling sea mocked her predicament.")])])])]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cc58eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterOne.vue
// module id = 78
// module chunks = 0